module.exports = __webpack_public_path__ + "static/media/Eventxtra Virtual Platform_v8-08.3b4825bd.png";